import React, {Component} from 'react';
import {Carousel,
    CarouselControl,
    CarouselItem
} from 'reactstrap';
import {connect} from 'react-redux'

@connect(
    state => ({
        auth: state.apa
    })
)
export class Presentation extends Component{

    state = {
        activeIndex: 0,
        animating: false
    }

    componentDidMount() {
        if(this.props.updateCurrentSlide) {
            if(this.props.user && this.props.auth.user.access_code) {
                this.setState({
                    activeIndex: this.props.auth.user.access_code.current_slide || 0
                })
            }
        }
    }

    render() {

        const {items, endPresentation} = this.props;
        const {activeIndex, animating} = this.state;

        const updateCurrentPage = (currentSlide) => {
            if(!this.props.updateCurrentSlide)
                return;
            const headers = {
                'Authorization': `Token ${this.props.auth.token}`,
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'current_slide': currentSlide
                }
            )
            fetch(
                'https://apabackend.quixtest.de/api/auth/user/update/',
                {headers, method: 'POST', body}
            )
        }

        const setActiveIndex = (activeIndex) => {
            this.setState({
                activeIndex: activeIndex
            }, () => updateCurrentPage(activeIndex))
        }

        const setAnimating = (animating) => {
            this.setState({
                animating: animating
            })
        }

        const goFirst = () => {
            setActiveIndex(0);
        }
        const goLast = () => {
            setActiveIndex(items.length - 1);
            endPresentation();
        }

        const next = () => {
            if (animating) return;
            if (activeIndex === items.length - 1) return;
            const nextIndex = activeIndex + 1;
            setActiveIndex(nextIndex);
            if(nextIndex === items.length - 1) {
                endPresentation();
            }
        }

        const previous = () => {
            if (animating) return;
            if (activeIndex === 0) return;
            const nextIndex = activeIndex - 1;
            setActiveIndex(nextIndex);
        }

        const slides = items.map((item) => {
            return (
                <CarouselItem
                    onExiting={() => setAnimating(true)}
                    onExited={() => setAnimating(false)}
                    key={item}
                >
                    <img style={{'margin': 'auto', 'display': 'block'}} src={item} alt={item} height={600}/>
                </CarouselItem>
            );
        });

        return (
            <div>
                <Carousel
                    interval={false}
                    activeIndex={activeIndex}
                    next={next}
                    previous={previous}
                >
                    {slides}
                    <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous}/>
                    <CarouselControl direction="next" directionText="Next" onClickHandler={next}/>
                </Carousel>
                <br/>
                <p className='text-right'>
                    Seite {activeIndex + 1} von {slides.length} /
                    <a href="#" onClick={e => {e.preventDefault(); goFirst();}} > Zum Anfang</a> /
                    <a href="#" onClick={e => {e.preventDefault(); goLast();}} > Zum Ende</a>
                </p>
            </div>
        );
    }
}
